import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarManufacturer } from 'src/app/public/car/models/car-manufacturer.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';


@Component({
    selector: 'app-carref-manufacturers',
    templateUrl: './carref-manufacturers.component.html',
    styleUrl: './carref-manufacturers.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefManufacturersComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() manufacturers: CarManufacturer[] = [];

  newItem: CarManufacturer = new CarManufacturer('', '', false);
  editedItem: CarManufacturer = new CarManufacturer('', '', false);

  displayedColumns: string[] = ['id', 'code', 'name', 'parts_only', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarManufacturer>(this.manufacturers);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.manufacturersFetchSubmit());
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['manufacturers']){
      this.dataSource.data = changes['manufacturers'].currentValue;
      
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarManufacturer('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarManufacturer('','',false);
      this.dataSource.data = [...this.dataSource.data, new CarManufacturer('','',false)];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.manufacturers.find((manuf: CarManufacturer) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.manufacturers.find((manuf: CarManufacturer) => manuf.id === id) );
    //console.log(this.editedItem);
  }

  SaveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.manufacturers.find((manuf: CarManufacturer) => manuf.id === id));
    this.editedItem = Object.assign({}, this.manufacturers.find((manuf: CarManufacturer) => manuf.id === id), this.editedItem);
    
    console.log(this.editedItem);
   
    if(id===0){
      this.store.dispatch (CarRefActions.manufacturerNewSubmit({manufacturer: this.editedItem }));
    } else{
      this.editedItem.id=id;
      this.store.dispatch (CarRefActions.manufacturerUpdateSubmit({manufacturer: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.manufacturerDeleteSubmit({manufacturerId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.name.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
